import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const cols = [
  {
    heading: 'Product',
    links: [['Features', '#features'], ['How It Works', '#how-it-works'], ['Pricing', '#pricing'], ['FAQ', '#faq']],
  },
  {
    heading: 'Legal',
    links: [['Privacy Policy', '/privacy'], ['Terms of Service', '/terms-of-service'], ['Refund Policy', '/refund-policy']],
  },
];

const contacts = [
  { label: 'support@reanoai.com', href: 'mailto:support@reanoai.com' },
  { label: '+91-9138187858',      href: 'tel:+919138187858' },
  { label: '+91-8708041134',      href: 'tel:+918708041134' },
];

const socials = [
  { label: 'LinkedIn',  path: 'M18.8 1.8H3.16A1.33 1.33 0 001.83 3.16v15.67A1.33 1.33 0 003.16 20.17h15.64A1.33 1.33 0 0020.13 18.83V3.13A1.34 1.34 0 0018.8 1.83zM7.24 17.42H4.55V8.69H7.24v8.73zM5.88 7.48a1.57 1.57 0 110-3.14 1.57 1.57 0 010 3.14zM17.45 17.42h-2.69v-4.23c0-1-.02-2.37-1.44-2.37-1.44 0-1.66 1.12-1.66 2.28v4.32H9.02V8.69h2.63v1.21h.04c.38-.73 1.32-1.5 2.71-1.5 2.9 0 3.43 1.9 3.43 4.38v4.64h-.38z' },
  { label: 'Twitter',   path: 'M20.12 5.91a8.2 8.2 0 01-2.36.65 4.1 4.1 0 001.8-2.27 8.2 8.2 0 01-2.6.99 4.1 4.1 0 00-7 3.74A11.65 11.65 0 012.74 4.7a4.1 4.1 0 001.27 5.47 4.08 4.08 0 01-1.86-.51v.05a4.1 4.1 0 003.29 4.02 4.1 4.1 0 01-1.85.07 4.1 4.1 0 003.83 2.85A8.23 8.23 0 011.94 17.72a11.6 11.6 0 006.29 1.84c7.55 0 11.68-6.25 11.68-11.67l-.01-.53a8.3 8.3 0 002.04-2.11z' },
  { label: 'Instagram', path: 'M11.03 7.57a3.46 3.46 0 100 6.93 3.46 3.46 0 000-6.93zm0 5.71a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zM14.76 1.83H7.24A5.41 5.41 0 001.83 7.24v7.52a5.41 5.41 0 005.41 5.41h7.52a5.41 5.41 0 005.41-5.41V7.24a5.41 5.41 0 00-5.41-5.41zm4.17 12.93a4.17 4.17 0 01-4.17 4.17H7.24a4.17 4.17 0 01-4.17-4.17V7.24a4.17 4.17 0 014.17-4.17h7.52a4.17 4.17 0 014.17 4.17v7.52zm-2.32-8.84a1.04 1.04 0 11-2.08 0 1.04 1.04 0 012.08 0z' },
];

export default function PulseFooter() {
  return (
    <motion.footer
      initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}
      viewport={{ once: true }} transition={{ duration: 0.5 }}
      style={{ background: '#020617', borderTop: '1px solid rgba(255,255,255,0.06)', position: 'relative', overflow: 'hidden' }}
    >
      {/* Dot grid */}
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        backgroundImage: 'radial-gradient(circle, rgba(71,158,195,0.08) 1px, transparent 1px)',
        backgroundSize: '28px 28px',
      }} />

      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1.4fr repeat(2, 1fr) 1.2fr',
          gap: '48px 32px',
          paddingTop: 60, paddingBottom: 52,
        }} className="pulse-footer-grid">

          {/* Brand */}
          <div>
            <a href="#" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', marginBottom: 16 }}>
              <div style={{
                width: 34, height: 34, borderRadius: 9,
                background: 'linear-gradient(135deg,#479EC3,#3B88A9)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <svg width="20" height="20" viewBox="0 0 32 32" fill="none">
                  <polyline points="4,16 8,16 10,9 13,23 16,12 19,20 22,16 28,16"
                    stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                </svg>
              </div>
              <div style={{ lineHeight: 1.15 }}>
                <div style={{ fontSize: 16, fontWeight: 800, letterSpacing: '-0.02em', color: '#fff' }}>Pulse</div>
                <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: '0.07em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.5)' }}>by Reano</div>
              </div>
            </a>
            <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', lineHeight: 1.65, marginBottom: 24, maxWidth: 220 }}>
              AI-powered customer engagement trained on your business — deployed in minutes.
            </p>
            <div style={{ display: 'flex', gap: 8 }}>
              {socials.map(s => (
                <a key={s.label} href="#" aria-label={s.label} className="pulse-footer-social">
                  <svg width="16" height="16" viewBox="0 0 22 22" fill="currentColor"><path d={s.path} /></svg>
                </a>
              ))}
            </div>
          </div>

          {/* Link cols */}
          {cols.map(col => (
            <div key={col.heading}>
              <h4 style={{ fontSize: 12, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.35)', marginBottom: 18 }}>
                {col.heading}
              </h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 11 }}>
                {col.links.map(([label, href]) => (
                  <li key={label}>
                    {href.startsWith('/') ? (
                      <Link to={href} className="pulse-footer-link">{label}</Link>
                    ) : (
                      <a href={href} className="pulse-footer-link">{label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact */}
          <div>
            <h4 style={{ fontSize: 12, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.35)', marginBottom: 18 }}>
              Contact
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 11 }}>
              {contacts.map(({ label, href }) => (
                <li key={label}>
                  <a href={href} className="pulse-footer-link">{label}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.08)',
          padding: '18px 0',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
        }}>
          <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
            <Link to="/privacy" className="pulse-footer-link-sm">Privacy Policy</Link>
            <Link to="/terms-of-service" className="pulse-footer-link-sm">Terms of Service</Link>
            <Link to="/refund-policy" className="pulse-footer-link-sm">Refund Policy</Link>
          </div>
          <p style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.35)' }}>
            © {new Date().getFullYear()} Reano AI Technologies. All rights reserved.
          </p>
        </div>
      </div>

      <style>{`
        .pulse-footer-link     { font-size: 14px; color: rgba(255,255,255,0.55); text-decoration: none; transition: color .15s; }
        .pulse-footer-link:hover { color: #fff; }
        .pulse-footer-link-sm  { font-size: 12.5px; color: rgba(255,255,255,0.35); text-decoration: none; transition: color .15s; }
        .pulse-footer-link-sm:hover { color: rgba(255,255,255,0.8); }
        .pulse-footer-social   { width: 34px; height: 34px; border-radius: 8px; background: rgba(71,158,195,0.12); border: 1px solid rgba(71,158,195,0.2); display: flex; align-items: center; justify-content: center; color: rgba(255,255,255,0.6); text-decoration: none; transition: background .15s, color .15s; }
        .pulse-footer-social:hover { background: rgba(71,158,195,0.25); color: #fff; }
        @media (max-width: 900px) { .pulse-footer-grid { grid-template-columns: 1fr 1fr !important; } }
        @media (max-width: 480px) { .pulse-footer-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </motion.footer>
  );
}
